var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9615 56.8245C22.9615 61.4974 19.1849 65.274 14.512 65.274C9.83918 65.274 6.0625 61.4974 6.0625 56.8245C6.0625 52.1517 9.83918 48.375 14.512 48.375H22.9615V56.8245ZM27.1863 56.8245C27.1863 52.1517 30.963 48.375 35.6358 48.375C40.3087 48.375 44.0853 52.1517 44.0853 56.8245V77.9483C44.0853 82.6211 40.3087 86.3978 35.6358 86.3978C30.963 86.3978 27.1863 82.6211 27.1863 77.9483V56.8245Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6373 22.899C30.9645 22.899 27.1878 19.1224 27.1878 14.4495C27.1878 9.77668 30.9645 6 35.6373 6C40.3102 6 44.0868 9.77668 44.0868 14.4495V22.899H35.6373ZM35.6373 27.1878C40.3102 27.1878 44.0868 30.9645 44.0868 35.6373C44.0868 40.3102 40.3102 44.0868 35.6373 44.0868H14.4495C9.77668 44.0868 6 40.3102 6 35.6373C6 30.9645 9.77668 27.1878 14.4495 27.1878H35.6373Z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4988 35.6373C69.4988 30.9645 73.2755 27.1878 77.9483 27.1878C82.6211 27.1878 86.3978 30.9645 86.3978 35.6373C86.3978 40.3102 82.6211 44.0868 77.9483 44.0868H69.4988V35.6373ZM65.274 35.6373C65.274 40.3102 61.4974 44.0868 56.8245 44.0868C52.1517 44.0868 48.375 40.3102 48.375 35.6373V14.4495C48.375 9.77668 52.1517 6 56.8245 6C61.4974 6 65.274 9.77668 65.274 14.4495V35.6373Z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8245 69.4988C61.4974 69.4988 65.274 73.2755 65.274 77.9483C65.274 82.6211 61.4974 86.3978 56.8245 86.3978C52.1517 86.3978 48.375 82.6211 48.375 77.9483V69.4988H56.8245ZM56.8245 65.274C52.1517 65.274 48.375 61.4974 48.375 56.8245C48.375 52.1517 52.1517 48.375 56.8245 48.375H78.0123C82.6852 48.375 86.4618 52.1517 86.4618 56.8245C86.4618 61.4974 82.6852 65.274 78.0123 65.274H56.8245Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.7e7b119932ecf478383c230ca33abed5.svg";
export { ForwardRef as ReactComponent };